<script>
import IconButton from "@/components/shared/IconButton.vue";
import Vue from "vue";

export default Vue.extend({
  name: "BorrowerProfileWarning",
  components: { IconButton },
  props: {
    communityRestrictedLoanableTypes: {
      default: "car",
      required: false,
      type: String,
    },
  },
  computed: {
    alertVariant() {
      switch (this.borrowerProfileStatus) {
        case "approved":
          return "success";
        case "incomplete":
          return "warning";
        case "submitted":
          return "info";
        case "suspended":
          return "danger";
      }
      return "";
    },
    borrowerProfileStatus() {
      if (this.user?.borrower?.suspended_at) {
        return "suspended";
      } else if (this.user?.borrower?.approved_at) {
        return "approved";
      } else if (this.user?.borrower?.submitted_at) {
        return "submitted";
      }
      return "incomplete";
    },
    user() {
      return this.$store.state.user;
    },
  },
});
</script>

<template>
  <b-alert show :variant="alertVariant" class="borrower-profile-warning">
    <h5 class="borrower-profile-warning__title mb-0">
      {{
        $t(`components.loan.borrower_profile_warning.${borrowerProfileStatus}.title`, {
          type: $t(
            `components.loan.borrower_profile_warning.${borrowerProfileStatus}.${communityRestrictedLoanableTypes}`
          ),
        })
      }}
    </h5>

    <p class="borrower-profile-warning__message">
      {{ $t(`components.loan.borrower_profile_warning.${borrowerProfileStatus}.message`) }}
    </p>

    <icon-button
      v-if="borrowerProfileStatus === 'incomplete'"
      to="/profile/borrower"
      pill
      class="borrower-profile-warning__action"
      :variant="alertVariant"
    >
      {{ $t(`components.loan.borrower_profile_warning.${borrowerProfileStatus}.action`) }}
    </icon-button>
  </b-alert>
</template>

<style lang="scss">
.borrower-profile-warning {
  &__title {
    font-weight: bold;
  }
}
</style>
